export default "__VITE_ASSET__F88jo3C7__"